// extracted by mini-css-extract-plugin
export default {"videoPlayBtn":"index_videoPlayBtn_a5qRn","playingBtn":"index_playingBtn_YscK6","pauseBtn":"index_pauseBtn_UZXf7","replayBtn":"index_replayBtn_fM4xH"};